import { createContext, useContext } from "react";

const TriggersDataContext = createContext({ triggers: [], fromDate: "", toDate: "" });

export const useTriggersData = () => useContext(TriggersDataContext);

export default TriggersDataContext;
